export default __webpack_public_path__ + "static/servicemesh-1-cff135a71a59751d4a87954dbef08c21.png";